import React, { createContext, useState, useContext } from 'react'

import IConsultaCartoesResponseDTO from '../domain/entities/IConsultaCartoesResponseDTO'

interface ICartaoContextState {
  cartao: IConsultaCartoesResponseDTO
  activeMenu: string
  setActiveMenu(value: string): void
  clear(): void
  setCartao(cartao: IConsultaCartoesResponseDTO): void
  saldo: number
  setSaldo(saldo: number): void
}

const CartaoContext = createContext<ICartaoContextState>(
  {} as ICartaoContextState,
)

export function useCartao(): ICartaoContextState {
  const context = useContext(CartaoContext)

  if (!context) {
    throw new Error('useCartao must be used within an CartaoProvider')
  }

  return context
}

export const CartaoProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<IConsultaCartoesResponseDTO>(
    {} as IConsultaCartoesResponseDTO,
  )
  const [activeMenu, setActiveMenu] = useState('')
  const [saldo, setSaldo] = useState(0)

  const clear = () => {
    setData({} as IConsultaCartoesResponseDTO)
  }

  const setSaldoCartao = (saldo: number) => {
    setSaldo(saldo)
  }

  const setCartao = (cartao: IConsultaCartoesResponseDTO) => {
    setData(cartao)
    setSaldoCartao(cartao?.saldo?.valor_saldo_disponivel ?? 0)
  }

  return (
    <CartaoContext.Provider
      value={{
        cartao: data,
        activeMenu,
        setActiveMenu,
        clear,
        setCartao,
        saldo,
        setSaldo: setSaldoCartao,
      }}
    >
      {children}
    </CartaoContext.Provider>
  )
}
